import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ClientService } from '@dss-libs/shared/data-access/clients';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';
import { LocalstorageConstants } from '@dss-libs/shared/type/common-types';
import { MatIconModule } from '@angular/material/icon';
import {
  AbstractModalComponent,
  BaseModalComponent,
  ButtonComponent,
  ModalListSkeletonComponent,
} from '@dss-libs/shared/ui/common-components';
import { Router } from '@angular/router';

@Component({
  selector: 'juno-libs-feature-switch-client-modal',
  imports: [
    TranslocoDirective,
    TranslocoDecimalPipe,
    MatIconModule,
    BaseModalComponent,
    ButtonComponent,
    ModalListSkeletonComponent,
  ],
  templateUrl: './switch-client-modal.component.html',
  styleUrl: './switch-client-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchClientModalComponent extends AbstractModalComponent {
  readonly #clientService = inject(ClientService);
  readonly loggedInClient = window.localStorage.getItem(LocalstorageConstants.CLIENT_ID);
  readonly #router = inject(Router);

  readonly userClientsResource = this.#clientService.userClientsResource();
  readonly isLoading = this.userClientsResource.isLoading;

  readonly #allClients = computed(() => (this.userClientsResource.hasValue() ? this.userClientsResource.value() : []));
  readonly currentClient = computed(() => this.#allClients().find((client) => client.id === this.loggedInClient));
  readonly userClients = computed(() => this.#allClients().filter((client) => client.id !== this.loggedInClient));

  changeClient(clientId: string) {
    window.localStorage.setItem(LocalstorageConstants.CLIENT_ID, clientId);
    window.location.reload();
  }

  getInitials(name: string): string {
    return name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join('');
  }

  navigateToCreateOrganization() {
    void this.#router.navigate(['/createClient/create-organization']);
  }
}
